// src/volumeRegistration/components/ProductRegistrationCard/ProductRegistrationCard.jsx

import React, { useState } from 'react';
import Card from '../../../common/components/Card/Card';
import Input from '../../../common/components/Input';
import './ProductRegistrationCard.scss';
import ProductCard from '../ProductCard/ProductCard';
import Checkbox from '../../../common/components/Checkbox/Checkbox';
import ErrorBox from '../../../common/components/ErrorBox';
import Button from '../../../common/components/Button';
import { I18n } from 'react-redux-i18n';

const ProductRegistrationCard = ({ selectedContract, inputRef, cardRef, onRegisterClick }) => {
    const [isUsingKeyboard, setIsUsingKeyboard] = useState(true);
    const [validationError, setValidationError] = useState();
    const [forceFocusOnProductGtin, setForceFocusOnProductGtin] = useState(false);

    // This gets invoked by <ProductCard submit={handleSubmit} …/>
    const handleSubmit = (product) => {
        // Instead of console.log, bubble up to parent
        console.log('🏷️ handleSubmit got:', product);
        onRegisterClick && onRegisterClick(product);
    };

    const resetForceFocusOnProductGtin = () => setForceFocusOnProductGtin(false);
    const clearValidationError = () => setValidationError(undefined);

    return (
        <Card title='Registro de aplicación de producto' innerRef={cardRef}>
            {selectedContract ? (
                <div className='product-registration-form'>
                    {/* Scanner / Keyboard toggles */}
                    <div className='checkboxes-row' style={{ marginTop: 12, marginBottom: 4 }}>
                        <Checkbox
                            id='isHandgun'
                            checked={!isUsingKeyboard}
                            onChange={() => {
                                setValidationError();
                                setIsUsingKeyboard(false);
                            }}
                            label={I18n.t('registration.scanner')}
                        />
                        <Checkbox
                            id='isKeyboard'
                            checked={isUsingKeyboard}
                            onChange={() => {
                                setValidationError();
                                setIsUsingKeyboard(true);
                            }}
                            label={I18n.t('registration.keyboard')}
                        />
                    </div>

                    {/* Validation errors */}
                    <div className='fix-height' style={{ marginBottom: 4 }}>
                        <ErrorBox
                            show={validationError !== undefined}
                            errorMessage={validationError || ''}
                        />
                    </div>

                    {/* The actual scan / manual entry card */}
                    <div className='product-card-container' style={{ marginTop: 0 }}>
                        <ProductCard
                            submit={handleSubmit}
                            onAnyChange={() => setValidationError()}
                            isUsingKeyboard={isUsingKeyboard}
                            delete={() => {}}
                            id={-1}
                            validateVn={() => true}
                            clearValidationError={clearValidationError}
                            forceGtinFocus={forceFocusOnProductGtin}
                            resetForceFocus={resetForceFocusOnProductGtin}
                            productsByOs={selectedContract?.productos || []}
                        />
                    </div>

                    {/* If you wanted a separate “Register” button here you could add it,
                        but since ProductCard already has its Add button wired to submit(),
                        all you need is the handleSubmit → onRegisterClick hookup above. */}
                </div>
            ) : (
                <p>Debe seleccionar un contrato para habilitar el registro.</p>
            )}
        </Card>
    );
};

export default ProductRegistrationCard;
